<script>
import GeneralTableMaterial from '@/views/Allestimenti/components/GeneralTableMaterial.vue'
import permissionMixin from '@/helpers/mixins/permissionMixin'
import { XlsxJson, XlsxRead } from 'vue-xlsx'

export default {
  name: 'AllestimentiForm',
  components: { XlsxJson, XlsxRead, GeneralTableMaterial },
  mixins: [permissionMixin],
  $_veeValidate: {
    validator: 'new',
  },
  props: ['module', 'id'],
  data() {
    return {
      pellCUIList: [],
      ripCUIList: [],
      file: null,
      isExcelValid: false,
      title: null,
      permissionDenied: false,
      allestimento: {
        name: null,
        Pel_M: [],
        Rip_M: [],
      },
    }
  },
  created() {
    this.title = this.id !== -1 ? this.$translate('modify_allestimenti') : this.$translate('new_allestimento')
  },
  async mounted() {
    let isAllowed = false
    switch (this.userInfo.type) {
      case 'A':
        isAllowed = true
        this.permissionDenied = false
        break
      case 'I':
        switch (this.userInfo.level) {
          case '1':
            isAllowed = true
            this.permissionDenied = true
            break
          default:
            isAllowed = true
            this.permissionDenied = false
            break
        }
        break
    }
    if (!isAllowed) await this.$router.push('/forbidden')

    this.$validator.extend('unique', async value => {
      let counter = 0
      await this.$db
        .collection('allestimenti')
        .where('name', '==', value)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            if (doc.id !== this.id) {
              counter++
            }
          })
        })

      return counter <= 0
    })

    if (this.id) {
      this.loadDatatoEdit()
    } else {
      if (this.$route.params.idtocopy) {
        this.loadDatatoCopy()
      } else {
        for (let material of ['Pel_M', 'Rip_M']) {
          this.allestimento[material] = []
        }
      }
    }
  },
  methods: {
    setMaterials(materials, materialType) {
      this.allestimento[materialType] = materials
    },
    //fatto
    loadDatatoCopy() {
      this.$db
        .collection('allestimenti')
        .doc(this.$route.params.idtocopy)
        .get()
        .then(doc => {
          this.allestimento = doc.data()
          this.allestimento.name = this.allestimento.name + '(copy)'
        })
    },
    // fatto
    loadDatatoEdit() {
      this.$db
        .collection('allestimenti')
        .doc(this.id)
        .get()
        .then(doc => {
          this.allestimento = doc.data()
        })
    },
    send() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('success_form'),
            type: 'is-success',
          })
          if (this.id && this.id !== -1) {
            this.$db
              .collection('allestimenti')
              .doc(this.id)
              .update(this.allestimento)
              .then(() => {
                this.$router.push({ name: 'allestimenti' })
              })
          } else {
            this.$db
              .collection('allestimenti')
              .add(this.allestimento)
              .then(() => {
                this.$router.push({ name: 'allestimenti' })
              })
          }
          return
        }
        this.$forceUpdate()
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('failed_form'),
          type: 'is-danger',
        })
      })
    },
    onFileChange(event) {
      this.$validator.validate('upload_input').then(result => {
        if (result) {
          this.file = event.target.files ? event.target.files[0] : null
        }
      })
    },
    loadTable(data) {
      const cleanData = data.slice(1)
      const pellList = []
      const ripList = []
      for (let row of cleanData) {
        if (row && row.MATERIALE && row.MATERIALE === 'PELLAME') {
          pellList.push(row.CUI)
        }
        if (row && row.MATERIALE && row.MATERIALE === 'RIPORTO') {
          ripList.push(row.CUI)
        }
      }
      if (pellList.length > 0) this.pellCUIList = pellList
      if (ripList.length > 0) this.ripCUIList = ripList
    },
    // validateExcel(data) {
    //   console.log('data', data)
    //   // this.isExcelValid = false
    //   // this.$validator.validate('shapeType').then(result => {
    //   //   if (result) {
    //   //     const totalColumn = this.countNotEmptyColumns(data)
    //   //     // the shape table to import is universal and not dipendant from module. Hidden fields for modular or eventually others
    //   //     const maxColumns =
    //   //       this.shape.type === 'high'
    //   //         ? this.$shapeTableHeadersHigh['fits'].length
    //   //         : this.$shapeTableHeadersLow['fits'].length
    //   //     if (totalColumn !== maxColumns) {
    //   //       this.isExcelValid = false
    //   //       this.$buefy.notification.open({
    //   //         duration: 3000,
    //   //         message: this.$translate('wrong_table'),
    //   //         type: 'is-danger',
    //   //       })
    //   //     } else {
    //   //       this.isExcelValid = true
    //   //     }
    //   //   }
    //   // })
    // },
    // countNotEmptyColumns(data) {
    //   const worksheet = data.Sheets['Foglio1']
    //   const range = XLSX.utils.decode_range(worksheet['!ref'])
    //   let nonEmptyColumnCount = 0
    //
    //   for (let col = range.s.c; col <= range.e.c; col++) {
    //     let isColumnEmpty = true
    //
    //     for (let row = range.s.r; row <= range.e.r; row++) {
    //       const cellAddress = { c: col, r: row }
    //       const cellRef = XLSX.utils.encode_cell(cellAddress)
    //       const cell = worksheet[cellRef]
    //
    //       if (cell && cell.v !== undefined && cell.v !== null && cell.v !== '') {
    //         isColumnEmpty = false
    //         break // Non serve controllare altre celle in questa colonna
    //       }
    //     }
    //
    //     // Conta la colonna solo se non è vuota
    //     if (!isColumnEmpty) {
    //       nonEmptyColumnCount++
    //     }
    //   }
    //
    //   return nonEmptyColumnCount
    // },
  },
}
</script>
<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-10">
          <h1 class="title">{{ $translate(title) | capitalize }}</h1>
        </div>
        <div class="column has-text-right">
          <button slot="trigger" type="button" class="button is-primary" @click="send">
            <b-icon icon="content-save-outline"></b-icon>
          </button>
        </div>
      </div>
      <b-field
        horizontal
        :label="$translate('name') | capitalize"
        :type="{ 'is-danger': errors.has('name') }"
        :message="errors.first('name')"
      >
        <b-input v-model="allestimento.name" v-validate="'required|unique'" name="name"> </b-input>
      </b-field>
      <b-field horizontal :message="errors.first('upload_input')" :type="{ 'is-danger': errors.has('upload_input') }">
        <label for="upload-input">
          <a class="button is-primary">
            <b-icon icon="upload" />
            <span>{{ $translate('upload_excel_button') }}</span>
          </a>
        </label>
        <input name="upload_input" v-validate="'ext:xlsx'" id="upload-input" type="file" @change="onFileChange" />
        <xlsx-read :file="file">
          <xlsx-json :options="{ header: ['TABELLA', 'MATERIALE', 'CUI'] }" @parsed="loadTable"></xlsx-json>
        </xlsx-read>
      </b-field>
      <b-tabs vertical>
        <b-tab-item
          v-for="materialType in ['Pel_M', 'Rip_M']"
          :key="materialType"
          :label="$translate(materialType) | capitalize"
          :materialtext="materialType"
        >
          <GeneralTableMaterial
            ref="MaterialTable"
            :module="module"
            :materialtext="materialType"
            :allestimentoTable.sync="allestimento[materialType]"
            :CUIList="materialType === 'Pel_M' ? pellCUIList : ripCUIList"
            @updateMaterials="materials => setMaterials(materials, materialType)"
          />
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<style scoped>
.container >>> p.image img {
  height: auto;
  width: 100px;
}
.container >>> thead th:nth-child(9),
.container >>> thead th:nth-child(10),
.container >>> thead th:nth-child(11),
.container >>> thead th:nth-child(12),
.container >>> thead th:nth-child(13) {
  display: none;
}
</style>
